import { Outlet } from 'react-router'

export default function LegalLayout() {
	return (
		<div className="container mx-auto max-w-3xl px-4 py-12">
			<article className="prose dark:prose-invert prose-headings:tracking-tight prose-h1:text-3xl prose-h1:font-bold prose-h1:sm:text-4xl text-base sm:text-lg">
				<Outlet />
			</article>
		</div>
	)
}
